import { PropsWithChildren } from "react";
import { useGlobalAppStore } from "../../../../context/store/useGlobalAppStore";

const OrdersTrendsNavLinkConditionalRenderer = ({ children }: PropsWithChildren) => {
  const { defaultOrderGateway } = useGlobalAppStore();
  const isDefaultOrderGatewayRta = defaultOrderGateway === "rta";

  return isDefaultOrderGatewayRta ? children : null;
};
export default OrdersTrendsNavLinkConditionalRenderer;
